var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 14.25V12H4.25v2.25h10.5zm0-3.75v-3H4.25v3h10.5zm0-4.5V3.75H4.25V6h10.5zm-10.5 9.75c-.413 0-.766-.147-1.06-.44a1.446 1.446 0 01-.44-1.06V3.75c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h10.5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v10.5c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H4.25z",
    fill: "#fff"
  })));
}
export default SvgPools;